<template>
  <b-card>
    <b-row class="position-relative">
      <b-col
        md="12"
      >
        <div class="d-flex align-items-center justify-content-lg-start">
          <Button
            v-if="showBackButton && actionType === 'save' || 'add'"
            :label="$t('List page')"
            size="md"
            icon="ArrowLeftIcon"
            show-icon
            class="mb-1"
            @click="backNavigationAction"
          />
        </div>
        <validation-observer ref="accountToDebitRules">
          <b-form>
            <b-row>
              <b-col md="5">
                <InputField
                  id="debit-field"
                  v-model="accountToDebitSearchParams.name"
                  :label="$t('Account To Debit')"
                  :placeholder="$t('Enter account to debit')"
                  rules="required"
                  type="text"
                />
              </b-col>

              <b-col md="5">
                <SelectField
                  id="debit-search-field"
                  v-model="accountToDebitSearchParams.field"
                  :label="$t('Search')"
                  :options="searchFieldOptions"
                  :reduce="option => option.value"
                  :error-name="$t('Search')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>

              <b-col md="2">
                <Button
                  :label="$t('Search')"
                  size="md"
                  class="mt-2"
                  block
                  @click="handleCustomerToDebitSearch"
                />
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>

        <div v-if="accountToDebit">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Account Summary')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="3">
                  <InputField
                    id="debit-account-name"
                    v-model="debitCustomer.accountName"
                    :label="$t('Account Name')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-account-number"
                    v-model="accountNumberToDebit"
                    :label="$t('Account Number')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-product-name"
                    v-model="debitCustomer.productName"
                    :label="$t('Product Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="debit-NUBAN"
                    v-model="debitCustomer.accountNumber"
                    :label="$t('NUBAN')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-branch"
                    v-model="debitCustomer.branchName"
                    :label="$t('Branch')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-account-status"
                    v-model="debitCustomer.accountStatus"
                    :label="$t('Account Status')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="debit-ledger-balance"
                    v-model="debitCustomer.ledgerBalance"
                    :label="$t('Ledger Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="debit-available-balance"
                    v-model="debitCustomer.availableBalance"
                    :label="$t('Available Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="debit-withdrawable-balance"
                    v-model="debitCustomer.withdrawableBalance"
                    :label="$t('Withdrawable Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="debit-overdraft-limit"
                    v-model="debitCustomer.overdraftLimit"
                    :label="$t('Overdraft Limit')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-account-officer"
                    v-model="debitCustomer.accountOfficer"
                    :label="$t('Account Officer')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="debit-tier-level"
                    v-model="debitCustomer.accountTierLevel"
                    :label="$t('Tier Level')"
                    type="text"
                    readonly
                  />
                </b-col>
              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>

        <div v-if="accountToDebit">
          <validation-observer ref="accountToCreditRules">
            <b-form>
              <b-row>
                <b-col md="5">
                  <InputField
                    id="credit-field"
                    v-model="accountToCreditSearchParams.name"
                    :label="$t('Account To Credit')"
                    :placeholder="$t('Enter account to credit')"
                    rules="required"
                    type="text"
                  />
                </b-col>

                <b-col md="5">
                  <SelectField
                    id="credit-search-field"
                    v-model="accountToCreditSearchParams.field"
                    label="Search"
                    :options="searchFieldOptions"
                    :reduce="option => option.value"
                    :error-name="$t('Search')"
                    rules="required"
                    item="label"
                    :placeholder="$t('Select')"
                  />
                </b-col>

                <b-col md="2">
                  <Button
                    :label="$t('Search')"
                    size="md"
                    class="mt-2"
                    block
                    @click="handleCustomerToCreditSearch"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>

        <div v-if="accountToCredit">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Account Summary')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="3">
                  <InputField
                    id="credit-account-name"
                    v-model="creditCustomer.accountName"
                    :label="$t('Account Name')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="credit-account-number"
                    v-model="accountNumberToCredit"
                    :label="$t('Account Number')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="credit-product-name"
                    v-model="creditCustomer.productName"
                    :label="$t('Product Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-NUBAN"
                    v-model="creditCustomer.accountNumber"
                    :label="$t('NUBAN')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="credit-branch"
                    v-model="creditCustomer.branchName"
                    label="Branch"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="credit-account-status"
                    v-model="creditCustomer.accountStatus"
                    :label="$t('Account Status')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-ledger-balance"
                    v-model="creditCustomer.ledgerBalance"
                    :label="$t('Ledger Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-available-balance"
                    v-model="creditCustomer.availableBalance"
                    :label="$t('Available Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-withdrawable-balance"
                    v-model="creditCustomer.withdrawableBalance"
                    :label="$t('Withdrawable Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-overdraft-limit"
                    v-model="creditCustomer.overdraftLimit"
                    :label="$t('Overdraft Limit')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="credit-account-officer"
                    v-model="creditCustomer.accountOfficer"
                    :label="$t('Account Officer')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="3">
                  <InputField
                    id="credit-tier-level"
                    v-model="creditCustomer.accountTierLevel"
                    :label="$t('Tier Level')"
                    type="text"
                    readonly
                  />
                </b-col>
              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>

        <div v-if="accountToDebit && accountToCredit">
          <validation-observer ref="cashDepositRules">
            <h5 class="text-capitalize mb-2 mt-4">
              {{ $t('Posting Details') }}
            </h5>
            <b-row>
              <b-col md="6">
                <InputNumberField
                  id="amount"
                  v-model="depositData.amount"
                  :label="$t('Amount')"
                  :placeholder="$t('Enter amount')"
                  error-name="Amount"
                  rules="required|positive"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="instrument-no"
                  v-model="depositData.instrumentNumber"
                  :label="$t('Instrument No')"
                  :placeholder="$t('Enter instrument no')"
                  type="text"
                  rules="required"
                  :error-name="$t('Instrument No')"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="depositor"
                  v-model="postingFormData.postingData.senderName"
                  :label="$t('Depositor')"
                  :placeholder="$t('Enter depositor')"
                  type="text"
                  for="depositor"
                  rules="required"
                  :error-name="$t('Depositor')"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="naration"
                  v-model="depositData.narration"
                  :label="$t('Naration')"
                  :placeholder="$t('Enter naration')"
                  type="text"
                  for="Naration"
                  rules="required"
                  error-name="naration"
                />
              </b-col>
            </b-row>
          </validation-observer>

          <div class="text-center mt-5">
            <Button
              :label="$t('Post')"
              :loading="isLoading"
              :disabled="isDisabled"
              size="lg"
              @click="handleSubmit"
            />
          </div>
        </div>

      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>
    <b-modal
      id="memo-info-modal"
      ref="memoInfoModal"
      :ok-title="$t('Cancel')"
      ok-only
      :title="$t('Memo')"
      ok-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        ref="memoListTable"
        select-mode="single"
        :items="memoGetData"
        responsive
        :fields="translatedMemoListHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No data available')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo, toAmount } from '@/helpers/formatAmount'
import InputField from '../../../../forms/InputField.vue'
import Button from '../../../../components/button/Button.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import SelectField from '../../../../forms/SelectField.vue'

const today = new Date()
const dateTime = moment(today).format()

export default {
  components: {
    BRow,
    BCol,
    BForm,
    InputField,
    Button,
    TablePagination,
    SelectField,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    InputNumberField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      showFormErrorAlert: false,
      accountToDebit: false,
      accountToCredit: false,
      isEditable: true,
      isLoading: false,
      isDisabled: false,
      customerType: 'debit',
      customerList: [],
      required,
      positive,
      showSpinner: false,
      showBackButton: false,
      sortDesc: false,
      currentPage: 1,
      selected: [],
      perPage: 10,
      sortBy: 'accountName',
      tillAccountNumber: '',
      filteredResult: [],
      accountNumberToDebit: null,
      accountNumberToCredit: null,
      branchToDebit: null,
      branchToCredit: null,
      accountToCreditSearchParams: {
        name: null,
        field: null,
      },
      accountToDebitSearchParams: {
        name: null,
        field: null,
      },
      depositData: {
        accountNumber: '',
        amount: '',
        recordType: 'Credit',
        narration: '',
        instrumentNumber: '',
        entryCode: 'C101',
        branchCode: '',
      },
      postingFormData: {
        postingData: {
          realDate: dateTime,
          postingType: 'AccountToAccountPosting',
          senderName: '',
          initiatedBy: '',
        },
      },
      posting: [],
      debitCustomer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficer: '',
        accountTierLevel: '',
        minimumBalanceRequired: 0,
        accountCreationChannel: null,
      },
      creditCustomer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficer: '',
        accountTierLevel: '',
        minimumBalanceRequired: 0,
        accountCreationChannel: null,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
      searchFieldOptions: [
        { label: 'Account Name', value: 'accountName' },
        { label: 'Account Number', value: 'accountNumber' },
        { label: 'Customer ID', value: 'customerID' },
        { label: 'Account Type', value: 'accountType' },
        { label: 'Reference Number', value: 'referenceNumber' },
      ],
      memoListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', label: 'Account Name' },
        { key: 'actionType', label: 'Action type' },
        { key: 'details', label: 'Reason' },
        { key: 'comments', label: 'Comments' },
        { key: 'initiatedBy', label: 'Initiated By' },
      ],
      memoGetData: [],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
      tillAccounts: 'operations/getTillAccount',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMemoListHeaders() {
      return this.memoListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    // this.fetchTillAccount()
    // this.fetchTillAccount()
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      postCashDeposit: 'posting/postingAction',
      getUserBalance: 'account/getCASABalanceAction',
    }),
    handleCustomerToDebitSearch() {
      try {
        this.$refs.accountToDebitRules.validate().then(async success => {
          if (success) {
            this.showSpinner = true
            const searchParams = Object.values(this.accountToDebitSearchParams)
            const [searchValue, searchKey] = searchParams

            const searchData = {
              search: { [searchKey]: searchValue },
              page: this.currentPage,
              limit: this.perPage,
              permission: 'LOCAL_FUNDS_TRANSFER_POSTING',
            }

            const response = await this.searchCustomerAccount(searchData)
            const { status, data } = response
            if (status === 200) {
              this.customerList = data.data
              this.$root.$emit('bv::show::modal', 'search-modal')
            }
          }
        })
        this.showSpinner = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },

    handleCustomerToCreditSearch() {
      try {
        this.$refs.accountToDebitRules.validate().then(async success => {
          if (success) {
            this.customerType = 'credit'
            this.showSpinner = true
            const searchParams = Object.values(this.accountToCreditSearchParams)
            const [searchValue, searchKey] = searchParams

            const searchData = {
              search: { [searchKey]: searchValue },
              page: this.currentPage,
              limit: this.perPage,
              permission: 'LOCAL_FUNDS_TRANSFER_POSTING',
            }

            const response = await this.searchCustomerAccount(searchData)
            const { status, data } = response
            if (status === 200) {
              this.customerList = data.data
              this.$root.$emit('bv::show::modal', 'search-modal')
            }
          }
        })
        this.showSpinner = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onSelectCustomer(items) {
      if (this.customerType === 'debit') {
        this.onSelectDebitCustomer(items)
      } else {
        this.onSelectCreditCustomer(items)
      }
    },
    async onSelectDebitCustomer(items) {
      try {
        this.hideModal('search-modal')
        this.showSpinner = true
        const [customer] = items
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'LOCAL_FUNDS_TRANSFER_POSTING' })
        const { data, status } = response

        if (status === 200 && data) {
          this.debitCustomer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            overdraftLimit: toBalance(data.overdraftLimit),
            ledgerBalance: toBalance(data.ledgerBalance),
            accountOfficer: data.accountOfficerName,
          }
          if (data.memos !== null) {
            this.memoGetData = data.memos
            this.$root.$emit('bv::show::modal', 'memo-info-modal')
          }
          this.depositData.narration = `Intrabank Transfer from ${customer.accountName} / ${customer.accountNumber}`
          this.accountNumberToDebit = customer.accountNumber
          this.branchToDebit = customer.branchCode
          this.accountToDebit = true
          this.showSpinner = false

          // this.hideModal('search-modal')
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },

    async onSelectCreditCustomer(items) {
      try {
        this.hideModal('search-modal')
        this.showSpinner = true
        const [customer] = items
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'LOCAL_FUNDS_TRANSFER_POSTING' })
        const { data, status } = response
        if (status === 200) {
          this.creditCustomer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            overdraftLimit: toBalance(data.overdraftLimit),
            ledgerBalance: toBalance(data.ledgerBalance),
            accountOfficer: data.accountOfficerName,
          }
          if (data.memos !== null) {
            this.memoGetData = data.memos
            this.$root.$emit('bv::show::modal', 'memo-info-modal')
          }
          this.accountToCredit = true
          this.accountNumberToCredit = customer.accountNumber
          this.branchToCredit = customer.branchCode
          // this.hideModal('search-modal')
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit() {
      this.$refs.cashDepositRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to initiate Intra-bank transfer of')
          this.confirm(this.intrabankTransferAction, { text: `${areYouSure} ${toAmount(this.depositData.amount)} ?` })
        }
      })
    },
    async intrabankTransferAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const postingApprovalModel = {
          amount: this.depositData.amount ? toKobo(this.depositData.amount) : 0,
          accountName: this.debitCustomer.accountName,
          initiatedBy: '',
          approvedBy: '',
          postingType: 'AccountToAccountPosting',
        }
        this.postingFormData.postingApprovalModel = postingApprovalModel
        this.postingFormData.postingData = {
          ...this.postingFormData.postingData,
          recipientName: this.creditCustomer.accountName,
          recipientBank: this.userDetails.institutionName,
          recipientAccountNumber: this.accountNumberToCredit,
          senderName: this.debitCustomer.accountName,
          senderBank: this.userDetails.institutionName,
          senderAccountNumber: this.accountNumberToDebit,
          transactionChannel: 'In-Branch',
          initiatedBy: this.userDetails.email,
        }
        this.postingFormData.postingEntry = [
          {
            accountNumber: this.accountNumberToCredit,
            accountName: this.creditCustomer.accountName,
            amount: this.depositData.amount ? toKobo(this.depositData.amount) : 0,
            recordType: 'Credit',
            narration: this.depositData.narration,
            instrumentNumber: this.depositData.instrumentNumber,
            entryCode: 'C-LTRF',
            branchCode: this.branchToCredit,
          },
          {
            accountNumber: this.accountNumberToDebit,
            accountName: this.debitCustomer.accountName,
            amount: this.depositData.amount ? toKobo(this.depositData.amount) : 0,
            recordType: 'Debit',
            narration: this.depositData.narration,
            instrumentNumber: this.depositData.instrumentNumber,
            entryCode: 'D-LTRF',
            branchCode: this.branchToDebit,
          }]
        const postingData = this.postingFormData
        const response = await this.postCashDeposit({ postingData, permission: 'LOCAL_FUNDS_TRANSFER_POSTING' })

        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          const successfulText = this.$t('Your Intra-bank transfer request was successful. Intra-bank transaction reference ID is')
          this.alertSuccess({ text: `${successfulText} ${data.referenceNumber}` })
          this.$router.push({ name: 'intra-bank-transfer-list' })
        }
        if (status === 200 && !data.isSuccessful) {
          const failedText = this.$t('Your Intra-bank transfer request failed. Reason:')
          this.alertError({ text: `${failedText} ${data.message}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.accountToDebitSearchParams = { ...null }
      this.depositData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
    },
    showSearchField() {
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.accountToDebitSearchParams = { ...null }
      this.accountToCreditSearchParams = { ...null }
    },
    resetModal() {
      this.showSpinner = false
      this.customerList = []
    },
    backNavigationAction() {
      this.$router.push({ name: 'intra-bank-transfer-list' })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
